import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Yo terminaba resolviendo todo sobre la marcha. Lo que más me ayudó fue empezar a tener estructura para situaciones repetidas.',
  name: 'Camila R.',
  role: 'Peluquera independiente — Buenos Aires'
}, {
  quote: 'El problema nunca fue la técnica. Era el caos operativo. Este tipo de sistema te ordena muchísimo.',
  name: 'Sofía M.',
  role: 'Estilista — Córdoba'
}, {
  quote: 'Mis clientas empezaron a notar más claridad y seguridad incluso en cómo respondía consultas.',
  name: 'Luciana G.',
  role: 'Home Studio — Rosario'
}];
export function Testimonials() {
  return <section className="bg-white py-8 px-5" data-id="element-303">
      <div className="max-w-xl mx-auto" data-id="element-304">
        <h2 className="md:text-3xl font-black text-center text-slate-900 mb-12 text-[20px]" data-id="element-305">
          💬 ¿Qué dicen profesionales que ya trabajan buscando más estructura?
        </h2>

        <div className="space-y-6" data-id="element-306">
          {testimonials.map((t, i) => <div key={i} className="bg-slate-50 border border-slate-100 p-8 rounded-2xl transition-all hover:bg-white hover:shadow-lg" data-id="element-307">
              <div className="flex gap-1 mb-4" data-id="element-308">
                {[...Array(5)].map((_, j) => <Star key={j} size={18} className="fill-brand-accent text-brand-accent" data-id="element-309" />)}
              </div>
              <p className="text-slate-600 italic text-base mb-6 leading-relaxed font-medium" data-id="element-310">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-4" data-id="element-311">
                <div className="w-10 h-10 rounded-full bg-brand-primary/10 flex items-center justify-center text-brand-primary font-bold" data-id="element-312">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-313">
                  <p className="font-bold text-slate-900 text-sm" data-id="element-314">{t.name}</p>
                  <p className="text-xs text-slate-400 font-bold uppercase tracking-wider" data-id="element-315">
                    {t.role}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}